import axios from 'axios';
import EventBus from '@/vue/EventBus';
import router from '@/vue/router';

export default {

  // fetch items from api
  fetchItems({
    state,
    commit,
    getters,
    dispatch
  }, replaceUrl) {
    commit('setLoading', true);

    // create object sent to request
    let postData = {
      ...getters.urlData,
      ...getters.serverData
    };

    // make XHR call and set state from response data
    axios
      .post(getters.apiUrl('url'), postData, {
        requestId: 'item_request'
      })
      .then(response => {
        dispatch('setStateData', response.data);
        commit('setCurrentSearch', postData.q);
        EventBus.emit('ITEMS_LOADED');

        // either replace or update the url
        if (replaceUrl) {
          router.replace({
            query: getters.urlData
          });
        } else {
          router.push({
            query: getters.urlData
          });
        }

        commit('setLoading', false);
      })
      .catch((thrown) => {
        if (axios.isCancel(thrown)) {
          return;
        }
        commit('setLoading', false);
      });
  },

  // set result data action
  // data is JSON response from itemsApi
  setStateData({
    commit
  }, data) {
    const payload = data?.result ?? data;

    commit('setItems', payload.items || []);
    commit('setItemsRemaining', payload.remaining ?? 0);
    commit('setItemsCount', payload.total ?? 0);
    commit('showNoResultsContent', !payload.items?.length);
    commit('setCurrentPage', payload.currentPage);
    commit('setTotalPages', payload.totalPages);
    commit('setTake', payload.takeCounter);

    if (payload.filters) {
      commit('setFilters', payload.filters);
    }
  },

  // fetch sort order options from api
  fetchSortOrderOptions({
    getters,
    commit
  }) {
    axios
      .post(getters.apiUrl('urlSortOrder'))
      .then(response => {
        commit('setSortOrder', response.data[0].Key);
        commit('setSortOrderOptions', response.data);
      })
  },

  // clear all the filters
  clearAllFilters({
    state,
    commit
  }) {
    // reset the take (to initial value) when a filter changes
    commit('setTake', state.initialTake);

    // update the filters data
    commit('setAllFiltersSelected', false);
  },

  // toggle a single filter
  toggleFilterValue({
    state,
    commit
  }, data) {
    // reset the take (to initial value) when a filter changes
    commit('setTake', state.initialTake);

    // update the filters data
    commit('setFilterSelected', data);
  },

  // toggle a range filter
  toggleRangeValue({
    state,
    commit
  }, data) {
    // reset the take (to initial value) when a filter changes
    commit('setTake', state.initialTake);

    // update the filters data
    commit('setFilterSelected', data);

    // if we have turned on the filter
    // we might need to select other siblings
    if (data.checked) {

      // if another filter is selected
      const currentIndex = state.filters[data.filterKey].children.findIndex((item, index) => item.selected && index !== data.itemKey);
      if (currentIndex > -1) {
        const siblingsSelected = [];

        // if the filter is greater than the other selected filter
        // and there are filters between
        // then select all filters in between
        if (currentIndex + 1 < data.itemKey) {
          for (let key = currentIndex + 1; key < data.itemKey; key++) {
            siblingsSelected.push(key);
          }
        }

        // if the filter is less than another filter selected
        // and there are filters between
        // then select all filters in between
        else if (currentIndex - 1 > data.itemKey) {
          for (let key = data.itemKey + 1; key < currentIndex; key++) {
            siblingsSelected.push(key);
          }
        }

        // set each sibling as selected
        siblingsSelected.forEach(siblingKey => {
          commit('setFilterSelected', {
            filterKey: data.filterKey,
            itemKey: siblingKey,
            checked: true
          });
        });
      }
    }
  }

};